function randomString(length) {
	var result = '';
	var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
	var charactersLength = characters.length;
	for (var i = 0; i < length; i++) {
		result += characters.charAt(Math.floor(Math.random() * charactersLength));
	}
	return result;
}

function randomNumber(length) {
	var result = '';
	var characters = '123456789';
	var charactersLength = characters.length;
	for (var i = 0; i < length; i++) {
		result += characters.charAt(Math.floor(Math.random() * charactersLength));
	}
	return result;
}

/**
 * Returns a random unused class name meant to be used as an Id
 *
 * @param {string} prefix
 */
function randomUniqueClassName(prefix = '') {
	let randomClassName;
	do {
		randomClassName = prefix + randomString(24);

	} while (document.querySelector(`.${randomClassName}`))

	return randomClassName;
}

/**
 * Returns a random unused id name meant to be used as an Id
 *
 * @param {string} prefix
 */
function randomUniqueId(prefix = '') {
	let randomId;
	do {
		randomId = prefix + randomString(24);

	} while (document.querySelector(`#${randomId}`))

	return randomId;
}

export {
	randomNumber,
	randomString,
	randomUniqueClassName,
	randomUniqueId
}
